import { Accordion, AccordionDetails, AccordionSummary, createStyles, makeStyles, Typography, useTheme } from '@material-ui/core';
import { ExpandMoreRounded as ExpandMoreRoundedIcon } from '@material-ui/icons';
import cn from 'classnames';
import * as React from 'react';
import BenefitsIcon from '../../assets/icons/BenefitsIcon';
import ConsequencesIcon from '../../assets/icons/ConsquencesIcon';
import { TranquiTheme } from '../../containers/App/theme';
import MarkdownRender from '../../dictionaries/MarkdownRender';
import RenderText from '../../dictionaries/RenderText';
import { DictionaryContextType } from '../../dictionaries/context/DictionaryContextTypes';
import { CssSpreadType } from '../../utils/css-spread-type';

interface BenefitsAndConsequencesProps {
  titleKey: string;
  contentKey: string,
  context?: DictionaryContextType;
  isBenefits?: boolean;
  contentText?: string | null;
  defaultExpanded?: boolean;
  dataTestid?: string;
}

const BenefitsAndConsequences: React.FC<BenefitsAndConsequencesProps> = (props) => {
  const { titleKey, contentKey, context, isBenefits = false, contentText = '', defaultExpanded, dataTestid } = props;
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const classes = useStyles();
  const theme = useTheme<TranquiTheme>();

  return (
    <Accordion
      classes={{ expanded: classes.root }}
      defaultExpanded={defaultExpanded}
      data-testid={dataTestid}
    >
      <AccordionSummary
        classes={{ root: classes.summary, content: classes.summaryContent }}
        expandIcon={<ExpandMoreRoundedIcon />}
      >
        {isBenefits ? (
          <BenefitsIcon
            size={18}
            color={theme.palette.indigo.main}
          />
        ) : (
          <ConsequencesIcon
            size={18}
            color={theme.palette.indigo.main}
          />
        )}
        <Typography className={cn(classes.title)}>
          <RenderText textKey={titleKey} />
        </Typography>
      </AccordionSummary>

      <AccordionDetails className={cn(classes.details)}>
        {(contentText && <MarkdownRender text={contentText} />)
        || (
        <RenderText
          textKey={contentKey}
          isMarkdown
          context={context}
        />
        )}
      </AccordionDetails>
    </Accordion>
  );
};

const useStyles = makeStyles((theme: TranquiTheme) => createStyles({
  root: {
    boxShadow: theme.shadows[2],
    borderRadius: theme.spacing(0.5),
  },
  summary: {
    minBlockSize: `${theme.spacing(6)}px !important`,
    '&.Mui-expanded': {
      backgroundColor: theme.palette.bg2.default,
    },
  },
  summaryContent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    columnGap: theme.spacing(1),
    margin: '0 !important',
  },
  title: {
    ...theme.typography.body2,
    fontSize: '0.8rem',
    color: theme.palette.indigo.main,
    fontWeight: 'bold',
    flex: 1,
    [theme.breakpoints.up('sm')]: {
      fontSize: '0.875rem',
    },
  },
  text: {
    margin: 0,
    ...(theme.typography.small as CssSpreadType),
    color: theme.palette.indigo.main,
  },
  details: {
    '& ul': {
      paddingInlineStart: theme.spacing(2.5),
    },
    '& li': {
      margin: theme.spacing(1, 0),
    },
  },
}));

export default BenefitsAndConsequences;
